import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../config/app-config';
import { ApiClientError } from '../../models/api/api-envelope';
import { buildApiUrl, encodeForm, FormFields, mapNetworkFailure } from './form-url-encoded';

@Injectable()
export class ApiHttpProvider {
  constructor(private http: HttpClient) {}

  postForm<T>(path: string, fields: FormFields): Promise<T> {
    const url = buildApiUrl(APP_CONFIG.apiBaseUrl, path);
    const body = encodeForm(fields);
    const options = {
      headers: new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded' })
    };

    return mapNetworkFailure(this.http.post<T>(url, body, options).toPromise(), function () {
      return new ApiClientError('network', 'No fue posible completar la solicitud.');
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/api-http/api-http.ts